import {keynestLink} from './keynestLink';

export const GUEST_KEY_LABELS = {LOCKER: 'Locker', KEYNEST: 'KeyNest', NO_ACTION: 'No Action', OTHERS: 'Others'};

// The API omits nulls. Always replace every Guest Key field when applying a response.
export function normalizeGuestKeySettings(value) {
    return {
        guest_key_type: value.guest_key_type || 'NO_ACTION',
        guest_key_info: value.guest_key_info ?? '',
        keynest_url: value.keynest_url ?? '',
        locker_password: value.locker_password ?? '',
        locker_auto_rotation_enabled: value.locker_auto_rotation_enabled ?? false,
        locker_code_updated_at: value.locker_code_updated_at ?? '',
    };
}

export function guestKeyDraft(settings) {
    return {...settings, locker_password: '', locker_code_confirmation: ''};
}

export function needsInitialLockerPassword(settings, draft) {
    return draft.guest_key_type === 'LOCKER' && (settings.guest_key_type !== 'LOCKER' || !settings.locker_password);
}

export function lockerPasswordError(password, confirmation, currentPassword) {
    if (!/^\d{4,8}$/.test(password.trim())) return 'Locker password must contain 4 to 8 digits.';
    if (password.trim() !== confirmation.trim()) return 'Locker password confirmation does not match.';
    if (password.trim() === currentPassword) return 'New locker password must be different from the current password.';
    return '';
}

export function guestKeySettingsError(settings, draft) {
    if (!Object.hasOwn(GUEST_KEY_LABELS, draft.guest_key_type)) return 'Select a Guest Key type.';
    if (draft.guest_key_type === 'KEYNEST' && draft.keynest_url?.trim() && !keynestLink(draft.keynest_url)) return 'Enter a complete HTTPS KeyNest link of at most 2048 characters.';
    if (draft.guest_key_type === 'LOCKER') {
        if (typeof draft.locker_auto_rotation_enabled !== 'boolean') return 'Choose Yes or No for the monthly automatic reminder.';
        if (needsInitialLockerPassword(settings, draft)) {
            return lockerPasswordError(draft.locker_password, draft.locker_code_confirmation);
        }
    } else if (draft.guest_key_type !== 'NO_ACTION' && draft.guest_key_info.trim().length > 255) {
        return 'Guest key information must not exceed 255 characters.';
    }
    return '';
}

export function guestKeySettingsPayload(settings, draft) {
    const isLocker = draft.guest_key_type === 'LOCKER';
    return {
        guest_key_type: draft.guest_key_type,
        ...(draft.guest_key_type === 'KEYNEST' ? {keynest_url: draft.keynest_url?.trim() ?? ''} : {}),
        locker_auto_rotation_enabled: isLocker ? draft.locker_auto_rotation_enabled : false,
        ...(isLocker ? (needsInitialLockerPassword(settings, draft) ? {
            locker_password: draft.locker_password.trim(),
            locker_code_confirmation: draft.locker_code_confirmation.trim(),
        } : {}) : draft.guest_key_type !== 'NO_ACTION' ? {guest_key_info: draft.guest_key_info.trim()} : {}),
    };
}

export function guestKeySettingsDirty(settings, draft) {
    return Boolean(settings && draft && JSON.stringify(guestKeySettingsPayload(settings, draft))
        !== JSON.stringify(guestKeySettingsPayload(settings, guestKeyDraft(settings))));
}
